/**
 * Fix issue with position:fixed navbar hiding all anchor link target
 * See https://stackoverflow.com/a/13067009
 */
export default function fixNavAnchorOffset(
  navEl,
  document = window.document,
  history = window.history,
  location = window.location,
) {
  const HISTORY_SUPPORT = !!(history && history.pushState);

  const anchorScrolls = {
    ANCHOR_REGEX: /^#[^ ]+$/,

    /**
     * Establish events, and fix initial scroll position if a hash is provided.
     */
    init() {
      this.scrollToCurrent();
      window.addEventListener('hashchange', this.scrollToCurrent.bind(this));
      document.body.addEventListener('click', this.delegateAnchors.bind(this));
    },

    /**
     * Return the offset amount to deduct from the normal scroll position.
     * Modify as appropriate to allow for dynamic calculations
     */
    getFixedOffset() {
      const navHeight = navEl.height || navEl.offsetHeight || 60;
      const additionalOffset = 12;
      return navHeight + additionalOffset;
    },

    /**
     * If the provided href is an anchor which resolves to an element on the
     * page, scroll to it.
     * @param  {String} href
     * @return {Boolean} - Was the href an anchor.
     */
    scrollIfAnchor(href, pushToHistory) {
      let rect, anchorOffset;

      if (!this.ANCHOR_REGEX.test(href)) {
        return false;
      }

      const match = document.getElementById(href.slice(1));

      if (match) {
        rect = match.getBoundingClientRect();
        anchorOffset = window.pageYOffset + rect.top - this.getFixedOffset();

        setTimeout(() => {
          window.scrollTo(window.pageXOffset, anchorOffset);
        }, 0);

        // Add the state to history as-per normal anchor links
        if (HISTORY_SUPPORT && pushToHistory) {
          history.pushState({}, document.title, location.pathname + href);
        }
      }

      return !!match;
    },

    /**
     * Attempt to scroll to the current location's hash.
     */
    scrollToCurrent() {
      this.scrollIfAnchor(window.location.hash);
    },

    /**
     * Search for element upwards (parent). Return null if element is not found
     */
    searchElement(elem, searchTarget) {
      while (elem && elem !== window) {
        if (elem.nodeName === searchTarget) {
          return elem;
        } else {
          elem = elem.parentNode;
        }
      }
      return null;
    },

    /**
     * If the click event's target was an anchor, fix the scroll position.
     */
    delegateAnchors(e) {
      const elem = e.target;

      let anchor = null;

      if (elem.nodeName === 'A') anchor = elem;
      else {
        // Search the path of the elements, this is needed if
        // the event target is nested inside an anchor tag.
        // Performance:
        //  - This however will incur an O(n) linear search which cost about ~ 1ms
        //  - The average case === element is not nested inside an anchor tag
        const composedPath = e.path || (e.composedPath && e.composedPath());
        anchor = (composedPath)
          ? [...composedPath].find(element => element.nodeName === 'A')
          : this.searchElement(elem, 'A')
        ;
      }

      if (
        anchor &&
        this.scrollIfAnchor(anchor.getAttribute('href'), true)
      ) {
        e.preventDefault();
      }
    },
  };

  window.addEventListener(
    'DOMContentLoaded', anchorScrolls.init.bind(anchorScrolls),
  );
};
